module.exports = __webpack_public_path__ + "img/wz-7-3-5.46185b23.jpg";